<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        02.14
        <br>2020
      </span>
      <span class="tiel">【人民网】感动！90后小伙新年里驱车29小时，将6吨生活物资送抵抗疫一线</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        <p>人民网北京1月28日电 (张桂贵)大年初一(1月25日)的傍晚，美菜网收到大冶市人民医院、黄石市中心医院两笔订单，两个医院下单近6吨物资，包括米面、食用油、干调、水饮等，要求24点前送达。美菜网的后台支持人员明白，这两笔特殊订单是一线医护人员的保障需求，这也是来自抗击疫情一线的无声命令。疫情严峻，如何能克服困难，把保障物资安全送达医院，揪着每个人的心。</p>
        <br>
        <p>配送需求上线后，90后司机谭德孝主动请缨。谭德孝分析，如果走高速，3个小时是足够的。但因高速临时封闭，不得不绕道107国道。先配送大冶市人民医院，再前往黄石市中心医院，全程约在175公里左右。当天19点左右，他载着物资的车辆就上路了。</p>
        <br>
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/new0309/b0309_9.png" width="640">
      </p>
      <div class="tet-js" style="text-align: center">装满一线生活物资的送货车辆</div>

      <div class="tet-js">
        <p>21点左右，谭德孝车行至鄂州、大冶交界处。因为道路施工，着急送货的谭德孝想从侧面绕过去，没想到雨后泥泞，加上车辆较重，货车陷入路边软土路基中。</p>
        <br>
        <p>当时，距离大冶市人民医院还有40公里。因连日降雨，又赶上道路中断，救援难度极大。为了货物安全，谭德孝坚守不动。此时，外面下着雨，最低温只有3度。</p>
        <br>
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/new0309/b0309_10.png" width="640">
      </p>
      <div class="tet-js" style="text-align: center">谭德孝的送货车辆陷入软土路基中</div>

      <div class="tet-js">
        <p>23点多，公司派来的另一位司机常联合带着饼干、饮料和家里煮的鸡蛋，以及装满热水的保温瓶，前往救援。雨夜路滑，还散落着从山上冲刷下来的泥土，70公里的路程，他开了2个小时。</p>
        <br>
        <p>26日凌晨1点多，在行至距谭德孝陷车地3.9公里的地方，因当地道路施工，常联合的货车也无法通行。心急如焚的常联合带着所有的衣服和食物下车，冒雨打着手机灯，凭借导航，愣是步行，找到了谭德孝的货车，赶紧让他填肚子、换衣服。</p>
        <br>
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/new0309/b0309_11.png" width="640">
      </p>
      <div class="tet-js" style="text-align: center">谭德孝发出的微信朋友圈</div>

      <div class="tet-js">
        <p>他俩挤在没有空调的驾驶室，就着常联合带去的食物、热水、衣服，坚守了一夜。第二天上午，热心的当地村民送来了衣服和鞋子。</p>
        <br>
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/new0309/b0309_12.png" width="640">
      </p>
      <div class="tet-js" style="text-align: center">送货车辆被吊车救出</div>

      <div class="tet-js">
        <p>经过大家的共同努力，受困的货车被吊车吊出来后，排除万难的谭德孝在1月26日深夜终于将菜品送到黄石市中心医院普爱院区，此时距离发车已经过了29小时。</p>
        <br>
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/new0309/b0309_13.png" width="640">
      </p>
      <div class="tet-js" style="text-align: center">谭德孝顺利将需求物资送达指定地点</div>

      <div class="tet-js">
        <p>“为了能让在控制疫情奋战一线的医生们没有生活质量上的担忧，我们作为后勤保障，就不能退却!”谭德孝说。</p>
        <br>
        <p>美菜网负责人告诉记者，谭德孝只是武汉抗疫保障队伍中的一员。一周来，该公司全力保障武汉抗击疫情物资供应，累计为武汉医院配送食材近10万斤，主要集中在米面油、乳饮、干调，其中大米2万5千斤左右，食用油1万1千斤左右，面粉5千斤左右。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
